var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPinkTrash(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 40,
    viewBox: "0 0 33 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.625 5H22.75V3.75C22.75 1.68227 21.0677 0 19 0H14C11.9323 0 10.25 1.68227 10.25 3.75V5H3.375C1.65188 5 0.25 6.40188 0.25 8.125V12.5C0.25 13.1903 0.809687 13.75 1.5 13.75H2.18313L3.26305 36.4284C3.35844 38.4312 5.00375 40 7.00875 40H25.9913C27.9963 40 29.6416 38.4312 29.737 36.4284L30.8169 13.75H31.5C32.1903 13.75 32.75 13.1903 32.75 12.5V8.125C32.75 6.40188 31.3481 5 29.625 5ZM12.75 3.75C12.75 3.06078 13.3108 2.5 14 2.5H19C19.6892 2.5 20.25 3.06078 20.25 3.75V5H12.75V3.75ZM2.75 8.125C2.75 7.78039 3.03039 7.5 3.375 7.5H29.625C29.9696 7.5 30.25 7.78039 30.25 8.125V11.25C29.8648 11.25 4.34633 11.25 2.75 11.25V8.125ZM27.2398 36.3095C27.208 36.977 26.6595 37.5 25.9913 37.5H7.00875C6.34039 37.5 5.79195 36.977 5.76023 36.3095L4.68594 13.75H28.3141L27.2398 36.3095Z",
    fill: "#A93E71"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.5 35C17.1903 35 17.75 34.4403 17.75 33.75V17.5C17.75 16.8097 17.1903 16.25 16.5 16.25C15.8097 16.25 15.25 16.8097 15.25 17.5V33.75C15.25 34.4403 15.8096 35 16.5 35Z",
    fill: "#A93E71"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M22.75 35C23.4403 35 24 34.4403 24 33.75V17.5C24 16.8097 23.4403 16.25 22.75 16.25C22.0597 16.25 21.5 16.8097 21.5 17.5V33.75C21.5 34.4403 22.0596 35 22.75 35Z",
    fill: "#A93E71"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M10.25 35C10.9403 35 11.5 34.4403 11.5 33.75V17.5C11.5 16.8097 10.9403 16.25 10.25 16.25C9.55969 16.25 9 16.8097 9 17.5V33.75C9 34.4403 9.55961 35 10.25 35Z",
    fill: "#A93E71"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPinkTrash);
export default __webpack_public_path__ + "static/media/pinkTrash.55c4d595d20eb474b8c67cc885e3ada3.svg";
export { ForwardRef as ReactComponent };